<template>
  <ButtonDropdown no-caret ghost-button data-test="sort-button">
    <WdsStack gap-sm align-center justify-center>
      <WdsIcon name="arrows" :size="16" weight="thick" />
      <WdsText>
        {{ $t('Sort') }}
      </WdsText>
    </WdsStack>
    <template #dropdown>
      <WdsStack direction-column gap-md class="tw-p-5 tw-w-64">
        <WdsText secondary :text="$t('Sort by')" />
        <WdsRadioGroup column name="Sort by" :checked="sort?.name">
          <WdsRadio
            v-for="option in sortOptions"
            :key="option.name"
            :value="option.name"
            :data-test="`sort-${option.name}`"
            class="tw-flex"
            @update:checked="sortBy(option)"
          >
            <WdsStack
              direction-row
              justify-space-between
              items-center
              class="tw-w-full"
              gap-sm
              :title="option.title"
            >
              <WdsText :text="option.primaryText" />
              <WdsText v-if="option.secondaryText" secondary :text="option.secondaryText" />
            </WdsStack>
          </WdsRadio>
        </WdsRadioGroup>
      </WdsStack>
    </template>
  </ButtonDropdown>
</template>

<script lang="ts" setup>
import { WdsIcon, WdsRadio, WdsRadioGroup, WdsStack, WdsText } from '@worksome/wds-components'
import { onMounted } from 'vue'
import { $t } from '@/composables/translation'
import ButtonDropdown from '@/components/ButtonDropdown.vue'
import { SortOrder } from '@/gql/graphql'
import { SortOption } from '@/components/BaseDataTable/composables/dataTableSort'

const emit = defineEmits(['sort'])

interface Props {
  sortOptions: SortOption[]
}

const props = defineProps<Props>()

const sort = defineModel<SortOption>('sort', { required: false })

const sortBy = (option: SortOption) => {
  sort.value = option
  const value = [
    {
      column: option.orderByColumn,
      order: option.sortOrder ?? SortOrder.Desc,
    },
  ]

  emit('sort', value)
}

onMounted(() => {
  if (props.sortOptions.length > 0 && !sort.value) {
    sort.value = props.sortOptions[0]
  }
})
</script>

<style lang="scss" scoped>
:deep(.wds-label) {
  @apply tw-w-full;
}

:deep(.wds-radio-label) {
  @apply tw-w-full;
}

:deep(.wds-label) {
  @apply tw-items-center;
}

:deep(.wds-radio-input) {
  @apply tw-items-center;
}
</style>
